__turbopack_context__.v({
  "container": "index-module-scss-module__JxS7Pa__container",
  "container__content": "index-module-scss-module__JxS7Pa__container__content",
  "container__content__sticky": "index-module-scss-module__JxS7Pa__container__content__sticky",
  "container__tables": "index-module-scss-module__JxS7Pa__container__tables",
  "discover_boat__container": "index-module-scss-module__JxS7Pa__discover_boat__container",
  "notes": "index-module-scss-module__JxS7Pa__notes",
  "notes__paragraph": "index-module-scss-module__JxS7Pa__notes__paragraph",
});
